import React from 'react'
import { cm } from '~/utils/utils'
import { Typography } from '../common/Typography'
import { DashboardIcon, PeopleIcon, AccountIcon, BillingIcon, UpgradeIcon } from './icons'

interface NavItemProps {
  icon: React.ReactNode
  label: string
  active?: boolean
  variant?: 'default' | 'upgrade'
  onClick?: () => void
}

const NavItem: React.FC<NavItemProps> = ({
  icon,
  label,
  active = false,
  variant = 'default',
  onClick
}) => {
  return (
    <button
      onClick={onClick}
      className={cm(
        'w-full h-10 px-4 flex items-center gap-3 rounded-lg transition-colors',
        active ? 'bg-[rgba(0,0,0,0.04)]' : 'hover:bg-[rgba(0,0,0,0.02)]',
        variant === 'upgrade' ? 'text-[#8571F4]' : 'text-[rgba(0,0,0,0.88)]'
      )}
    >
      <span className='w-5 h-5 flex items-center justify-center'>{icon}</span>
      <Typography
        fontFamily='geist'
        fontSize='bodyMd'
        fontWeight={active ? 'semibold' : 'medium'}
        style={{
          color: variant === 'upgrade' ? '#8571F4' : active ? '#000000' : 'rgba(0, 0, 0, 0.88)',
          lineHeight: '22px'
        }}
      >
        {label}
      </Typography>
    </button>
  )
}

interface UsageSidebarProps {
  activeItem?: string
  onNavigate?: (item: string) => void
  className?: string
}

export const UsageSidebar: React.FC<UsageSidebarProps> = ({
  activeItem = 'dashboard',
  onNavigate,
  className
}) => {
  return (
    <div
      className={cm(
        'w-[180px] h-full bg-[#FCFCFC] border-r border-[#EAEAEA] flex flex-col flex-shrink-0',
        className
      )}
    >
      {/* Account Section */}
      <div className='px-4 pt-6'>
        <Typography
          fontFamily='geist'
          fontSize='bodySm'
          fontWeight='semibold'
          style={{ color: 'rgba(0, 0, 0, 0.45)', lineHeight: '14px', paddingLeft: '16px' }}
        >
          Account
        </Typography>
        <div className='mt-3 flex flex-col gap-1'>
          <NavItem
            icon={<DashboardIcon className='w-5 h-5' />}
            label='Dashboard'
            active={activeItem === 'dashboard'}
            onClick={() => onNavigate?.('dashboard')}
          />
          <NavItem
            icon={<PeopleIcon className='w-5 h-5' />}
            label='People'
            active={activeItem === 'people'}
            onClick={() => onNavigate?.('people')}
          />
          <NavItem
            icon={<AccountIcon className='w-5 h-5' />}
            label='Account'
            active={activeItem === 'account'}
            onClick={() => onNavigate?.('account')}
          />
        </div>
      </div>

      {/* Divider */}
      <div className='mx-4 my-4 h-px bg-[#EAEAEA]' />

      {/* Billing Section */}
      <div className='px-4'>
        <div className='flex flex-col gap-1'>
          <NavItem
            icon={<BillingIcon className='w-5 h-5' />}
            label='Billing'
            active={activeItem === 'billing'}
            onClick={() => onNavigate?.('billing')}
          />
          <NavItem
            icon={<UpgradeIcon className='w-5 h-5' />}
            label='Upgrade'
            variant='upgrade'
            active={activeItem === 'upgrade'}
            onClick={() => onNavigate?.('upgrade')}
          />
        </div>
      </div>
    </div>
  )
}

export default UsageSidebar
